import axios from "axios";

const CLOUD_NAME = "dvrjd3hei";
const UPLOAD_PRESET = "Ocimum";

export const uploadToCloudinary = async (file, folder = "") => {
    if (!file) return null;

    const formData = new FormData();

    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    if (folder) {
        formData.append("folder", folder);
    }

    try {
        const response = await axios.post(
            `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`,
            formData
        );

        return response.data.secure_url.replace(
            "/upload/",
            "/upload/f_auto,q_auto/"
        );
    } catch (error) {
        console.log(error);
        throw error;
    }
};